// Erreur metier de POST calculImputations : gestionnaire en saisie par
// service qui n'est gestionnaire d'aucun service habilite sur le perimetre
export const CODE_ERREUR_CALCUL_AUCUN_SERVICE = 'erreur_calcul_aucun_service';

// Erreurs metier de l'API au format [{ code, message[] }]
export const isErreurCalculAucunService = (erreur: unknown) => {
	const data = (erreur as { response?: { data?: unknown } })?.response?.data;

	return (
		Array.isArray(data) &&
		data.some(
			(erreurMetier) => erreurMetier?.code === CODE_ERREUR_CALCUL_AUCUN_SERVICE,
		)
	);
};
